/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: Cognos Analytics Home (C) Copyright IBM Corp. 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

define([
	'ca-content/content/content'
], function (content) {

	class ContentPageCallbacks {
		constructor(options) {
			this.glassContext = options.glassContext;
		}

		getCustomFolderUrl() {
			const teamFolders = this.glassContext.getCoreSvc('.UserProfile').userProfileSettings.ui_teamFolders;
			const pathRef = teamFolders && teamFolders.pathRef;
			return pathRef ? content.ContentServiceUrls.getPathURL(pathRef) : null;
		}

		getSamplesFolderUrl() {
			const samplesFolderPathRef = '.public_folders/Samples';
			const samplesUrl = content.ContentServiceUrls.getPathURL(samplesFolderPathRef);
			const options = {
				dataType: 'json',
				type: 'GET',
				url: samplesUrl,
				data: {
					'fields': 'id,type,defaultName,ancestors,shown,hidden'
				}
			};
			return this.glassContext.getCoreSvc('.Ajax').ajax(options).then((objInfo) => {
				if (objInfo && objInfo.data.data.length > 0) {
					let metaData = objInfo.data.data[0];
					return !metaData.hidden ? samplesUrl : null;
				} else {
					return null;
				}
			}).catch(() => {
				return null;
			});
		}

		getMyPortalsUrl() {
			return this.glassContext.getCoreSvc('.Config').getConfigValue('ContentApps/enableMyPortalPages').then((isFeatureEnabled) => {
				if (isFeatureEnabled === 'true') {
					return content.ContentServiceUrls.getMyPortalsURL();
				} else {
					return null;
				}
			});
		}

		getCustomFolderLabel() {
			const teamFolders = this.glassContext.getCoreSvc('.UserProfile').userProfileSettings.ui_teamFolders;
			if (teamFolders) {
				let path = teamFolders.pathRef;
				if (path) {
					path = path.replace(/^\//, '');
				}
				const pathURL = content.ContentServiceUrls.getPathURL(path);

				const options = {
					dataType: 'json',
					url: pathURL
				};

				return this.glassContext.getCoreSvc('.Ajax').ajax(options).then((result) => {
					const cmObj = result.data.data[0];
					const label = cmObj.defaultName;
					return label;
				}).catch(() => {
					return null;
				});

			}
		}


	}

	return ContentPageCallbacks;
});